/**
 * Rótulo de exibição dos valores de domínio que ficam gravados em PORTUGUÊS.
 *
 * Tipo de perigo e ciclo de vida são valor canônico: vão para a API e voltam do
 * banco exatamente como estão (ver TIPOS_PERIGO e CICLOS_VIDA_BASE em
 * modal-editar-parte/constants). Traduzir o dado quebraria as comparações e
 * misturaria idiomas na mesma base — então o português fica no dado e só a
 * etiqueta na tela acompanha o idioma.
 *
 * As chaves moram em `apreciacaoModais.editarParte.*.opcao.*` porque foi o modal
 * que primeiro precisou delas; este módulo existe para que a tabela de riscos
 * use o MESMO mapa em vez de repetir o valor cru.
 *
 * Valor fora da lista fixa (veio da IA, de importação ou de apreciação antiga)
 * não tem chave: devolve o próprio valor, nunca a chave crua.
 */

type Tradutor = (chave: string, variaveis?: Record<string, string | number>) => string;

function rotulo(t: Tradutor, prefixo: string, valor: string): string {
  const chave = `${prefixo}.${valor}`;
  const traduzido = t(chave);
  return traduzido === chave ? valor : traduzido;
}

export function rotuloTipoPerigo(t: Tradutor, tipo: string): string {
  return rotulo(t, 'apreciacaoModais.editarParte.tiposPerigo.opcao', tipo);
}

export function rotuloCicloVida(t: Tradutor, ciclo: string): string {
  return rotulo(t, 'apreciacaoModais.editarParte.cicloVida.opcao', ciclo);
}

/**
 * `tipoPerigo` e `cicloVida` são gravados como lista separada por vírgula
 * ("Operação Normal, Ajuste, Limpeza"). Traduz item a item e recompõe.
 */
export function rotuloListaDominio(
  t: Tradutor,
  valor: string | null | undefined,
  traduzirItem: (t: Tradutor, item: string) => string
): string {
  if (!valor) return '';
  return valor
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => traduzirItem(t, item))
    .join(', ');
}
